// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"11c7d656","336":"17f5d965","453":"525d06e6"}[chunkId] + ".chunk.js";
};